/**
 * Admin leads endpoints.
 *
 * Extracted from `src/services/api.ts` (Fase 10 Slice 10.6).
 *   - GET    /admin/leads        — paginated list with filters
 *   - GET    /admin/leads/funnel — by_status counters
 *   - DELETE /admin/leads        — bulk delete by ids
 *
 * Re-exported from services/api.ts so existing call-sites keep working.
 */

import { apiClient } from '../client';
import type { LeadsResponse } from '../../types/config';

export const adminListLeads = async (params?: {
  status?: string;
  email?: string;
  dog_name?: string;
  accepts_marketing?: boolean;
  date_from?: string;
  date_to?: string;
  page?: number;
  per_page?: number;
}): Promise<LeadsResponse> => {
  const response = await apiClient.get<LeadsResponse>('/admin/leads', { params });
  return response.data;
};

export const adminLeadsFunnel = async (params?: {
  date_from?: string;
  date_to?: string;
}): Promise<{ total: number; by_status: Record<string, number> }> => {
  const response = await apiClient.get<{
    total: number;
    by_status: Record<string, number>;
  }>('/admin/leads/funnel', { params });
  return response.data;
};

export const adminDeleteLeads = async (ids: string[]): Promise<{ deleted: number }> => {
  const response = await apiClient.delete<{ deleted: number }>('/admin/leads', {
    data: { ids },
  });
  return response.data;
};
